<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <div v-if="p_idAtencion != 0">
              <router-link to="/atencion">Atenciones</router-link> >
              <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numero }}</router-link>
              > Vacunas
            </div>
            <div v-else>
              <router-link to="/persona">Personas</router-link> >
              <router-link :to="'/personaform/' + p_pagina + '/' + p_idPersona">{{ datoPersona.nombreCompleto }}</router-link>
              > Vacunas
            </div>
          </div>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de vacunas"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>
<Modal v-model:modelValue="showModalHelp" title="Ayuda — Vacunas del Paciente">
  <AyudaVacunaPers />
</Modal>
    <hr>

    <!-- Master -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-7">
                  <label class="form-label">Nombre</label>
                  <input type="text" class="form-control" v-model="datoPersona.nombreCompleto" disabled>
                </div>
                <div class="col-2">
                  <label class="form-label">{{ datoPersona.tipoIdenNombre }}</label>
                  <input type="text" class="form-control" v-model="datoPersona.documento" disabled>
                </div>
                <div class="col-3 d-flex align-items-end justify-content-end">
                  <button @click.prevent="mostrarOcultarBloque">
                    {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
                  </button>
                </div>
              </div>
            </div>

            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Email</label></div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="datoPersona.email" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Estado Civil</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.estadoCivilNombre" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Localidad</label></div>
                  <div class="col-6">
                    <input type="text" class="form-control" v-model="datoPersona.localidadNombre" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Teléfono</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.telefono" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Primer Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerNombre" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Segundo Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoNombre" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Primer Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerApellido" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Segundo Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoApellido" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Fecha de Nacimiento</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" :value="getFormattedDate(datoPersona.fechaNac)" disabled>
                  </div>
                  <div class="col-2"><label class="form-label">Sexo</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" :value="sexoDecodificado" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label class="form-label">Dirección</label>
                    <input type="text" class="form-control" v-model="datoPersona.direccion" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
<div class="row g-2">
  <div class="col-6 col-md-2">
    <label class="form-label">IdPersona</label>
    <input type="text" class="form-control form-control-sm" v-model="datoPersona.idPersona" disabled>
  </div>
  <div class="col-6 col-md-2">
    <label class="form-label">IdEmpresa</label>
    <input type="text" class="form-control form-control-sm" v-model="datoPersona.idEmpresa" disabled>
  </div>
  <div class="col-6 col-md-2">
    <label class="form-label">UsuarioReg</label>
    <input type="text" class="form-control form-control-sm" v-model="datoPersona.idUsuarioReg" disabled>
  </div>
  <div class="col-6 col-md-2">
    <label class="form-label">FechaReg</label>
    <input type="text" class="form-control form-control-sm" :value="getFormattedDate(datoPersona.fechaReg)" disabled>
  </div>
  <div class="col-6 col-md-2">
    <label class="form-label">UsuarioAct</label>
    <input type="text" class="form-control form-control-sm" v-model="datoPersona.idUsuarioAct" disabled>
  </div>
  <div class="col-6 col-md-2">
    <label class="form-label">FechaAct</label>
    <input type="text" class="form-control form-control-sm" v-model="datoPersona.fechaAct" disabled>
  </div>
</div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!--  DataTable de Vacunas  -->
    <DataTable
      :data="vacunaperssFiltered"
      :columns="columnasVacuna"
      idField="idVacunaPers"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay vacunas registradas."
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idVacunaPers)"
    >
      <template #acciones-extra>
        <div class="col-auto">
          <button class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
            @click="registrarVacunasRecomendadas" title="Registro de Vacunas Recomendadas">
            <span class="material-symbols-outlined" style="font-size:16px">vaccines</span>
            Recomendadas
          </button>
        </div>
        <div class="col-auto">
          <button class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
            @click="tablaPersona" title="Ver tabla">
            <span class="material-symbols-outlined" style="font-size:16px">table</span>
            Tabla
          </button>
        </div>
        <div class="col-auto d-flex align-items-center gap-2">
          <label class="small fw-bold mb-0">Vacuna</label>
          <select v-model="filtroVacuna" class="form-select form-select-sm" style="min-width:160px">
            <option value="">Todas</option>
            <option v-for="v in vacunas" :key="v.idVacuna" :value="v.nombre">{{ v.nombre }}</option>
          </select>
        </div>
      </template>
    </DataTable>
    <!-- ↑ UN solo cierre de DataTable, sin nada después -->

    <!-- Modal Vacuna -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title">{{ titulo }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Vacuna</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoVacunaPers.idVacuna">
                      <option v-for="v in vacunas" :value="v.idVacuna" :key="v.idVacuna">{{ v.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Vacuna Prod</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoVacunaPers.idVacunaProd">
                      <option v-for="vp in vacunaProds" :value="vp.idVacunaProd" :key="vp.idVacunaProd">
                        {{ vp.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Fecha Aplicación</label></div>
                  <div class="col-10">
                    <input type="date" class="form-control"
                      v-model="formattedFechaNac"
                      :min="minDate"
                      :max="maxDate"
                      required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Observación</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoVacunaPers.observacion"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Lote</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoVacunaPers.lote"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>
              <button @click.prevent="mostrarOcultarBloque02">
                {{ mostrarBloque02 ? '(-) Menos información' : '(+) Más información' }}
              </button>
              <div v-if="mostrarBloque02" class="mb-3 mt-2">
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="form-label">IdVacunaPers</label></div>
                    <div class="col-10">
                      <input type="text" class="form-control" v-model="datoVacunaPers.idVacunaPers" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="form-label">IdPersona</label></div>
                    <div class="col-10">
                      <input type="text" class="form-control" v-model="datoVacunaPers.idPersona" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="form-label">IdUsuarioReg</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoVacunaPers.idUsuarioReg" disabled>
                    </div>
                    <div class="col-2"><label class="form-label">FechaReg</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoVacunaPers.fechaReg" disabled>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="form-label">IdUsuarioAct</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoVacunaPers.idUsuarioAct" disabled>
                    </div>
                    <div class="col-2"><label class="form-label">FechaAct</label></div>
                    <div class="col-4">
                      <input type="text" class="form-control" v-model="datoVacunaPers.fechaAct" disabled>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button class="btn btn-success" @click.prevent="guardarVacunaPers" v-if="btnCrear_det">
              <span class="material-symbols-outlined align-middle" style="font-size:32px;">save</span> Guardar
            </button>
            <button class="btn btn-success" @click.prevent="guardarEditVacunaPers" v-if="btnEditar_det">
              <span class="material-symbols-outlined align-middle" style="font-size:32px;">update</span> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import AyudaVacunaPers from '@/views/ayuda/AyudaVacunaPers.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import dateFormat from '@/modules/dateFormat.js'
import api from "@/services/api"
import * as $ from 'jquery'
window["$"] = $
window["jQuery"] = $
import Swal from 'sweetalert2'

export default {
  props: {
    p_pagina:         { type: String, required: true },
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_numero:         { type: String, required: true },
    p_idPersona:      { type: Number, required: true },
    p_edad:           { type: Number, required: true },
  },
  components: { Layout, Footer, DataTable, AyudaVacunaPers },
  data() {
    return {
      // Master
      datoPersona: {},
      mostrarBloque: false,
      mostrarBloque02: false,
      showModalHelp: false,
      // Detail
      vacunaperss: [],
      datoVacunaPers: {},
      titulo: '',
      btnCrear_det: false,
      btnEditar_det: false,
      modalWindow: true,
      vacunas: [],
      vacunaProds: [],
      filtroVacuna: '',
      // Columnas del DataTable
      columnasVacuna: [
        { field: 'vacunaNombre',    label: 'Nombre' },
        {
          field: 'fechaApli',
          label: 'Fecha Aplicación',
          format: (val) => dateFormat.getFormattedDate(val),
        },
        { field: 'observacion',     label: 'Observación' },
        { field: 'vacunaProdNombre', label: 'Producto' },
        { field: 'lote',            label: 'Lote' },
      ],
    }
  },
  watch: {
    'datoVacunaPers.idVacuna'(newIdVacuna) {
      if (newIdVacuna) this.fetchVacunaProds(newIdVacuna)
    },
  },
  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
    formattedFechaNac: {
      get() {
        if (!this.datoVacunaPers.fechaApli) return ''
        const date = new Date(this.datoVacunaPers.fechaApli)
        const year  = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day   = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },
      set(value) {
        const date = new Date(value)
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
        this.datoVacunaPers.fechaApli = date.toISOString()
      },
    },
    // Filtra los datos que el DataTable ya pagina internamente
    vacunaperssFiltered() {
      if (!this.filtroVacuna) return this.vacunaperss
      return this.vacunaperss.filter(v => v.vacunaNombre === this.filtroVacuna)
    },
    sexoDecodificado() {
      const s = this.datoPersona.sexo
      if (s === 'M') return 'Masculino'
      if (s === 'F') return 'Femenino'
      return s || ''
    },
    minDate() {
      return this.formatDate(this.datoPersona.fechaNac)
    },
    maxDate() {
      return new Date().toISOString().split('T')[0]
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.abrirEditar(this.p_idPersona)
    this.getDataTodos()
    this.fetchVacunas()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    formatDate(date) {
      if (!date) return ''
      const d     = new Date(date)
      const year  = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day   = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    mostrarOcultarBloque()   { this.mostrarBloque   = !this.mostrarBloque },
    mostrarOcultarBloque02() { this.mostrarBloque02 = !this.mostrarBloque02 },
    //  Master
    abrirEditar(idPersona) {
      if (idPersona) {
        api.get('/vwpersonas/' + idPersona).then(resp => {
          this.datoPersona = resp.data
        })
      }
    },
    //  Detail
    getDataTodos() {
      api.get('/vwvacunaperss/idpersona/' + this.p_idPersona).then(response => {
        this.vacunaperss = response.data.reverse()
      })
    },
    validarFormDet() {
      return validarForm(
        this.datoVacunaPers,
        ['idVacuna', 'fechaApli'],
        ['Vacuna', 'Fecha de aplicación']
      )
    },
    async guardarVacunaPers() {
      if (this.validarFormDet() !== 1) return
      try {
        this.datoVacunaPers.idPersona    = this.datoPersona.idPersona
        this.datoVacunaPers.idUsuarioReg = window.sessionStorage.getItem("idUsuario")
        await api.post('/vacunaperss', this.datoVacunaPers)
        closeModal('ventanaModal')
        Swal.fire({ title: "¡Correcto!", text: "Vacuna registrada exitosamente!", icon: "success" })
        this.getDataTodos()
      } catch {
        Swal.fire({ title: "¡Error!", text: "¡Inténtelo de nuevo!", icon: "error" })
      }
    },
    async guardarEditVacunaPers() {
      if (this.validarFormDet() !== 1) return
      try {
        await api.post('/vacunaperss', this.datoVacunaPers)
        closeModal('ventanaModal')
        Swal.fire({ title: "¡Correcto!", text: "Vacuna actualizada exitosamente!", icon: "success" })
        this.getDataTodos()
      } catch (error) {
        Swal.fire({ title: "¡Error!", text: "¡Inténtelo de nuevo!", icon: "error" })
        Object.values(error.response?.data?.errors ?? {}).forEach(e =>
          Swal.fire({ text: String(e), icon: "info" })
        )
      }
    },
    abrirModalCrear() {
      this.datoVacunaPers = {}
      this.titulo         = 'Nuevo Registro'
      this.btnCrear_det   = true
      this.btnEditar_det  = false
      openModal('ventanaModal')
    },
    abrirModalEditar(idVacunaPers) {
      this.titulo        = 'Editar Registro'
      this.btnCrear_det  = false
      this.btnEditar_det = true
      if (idVacunaPers) {
        api.get('/vwvacunaperss/' + idVacunaPers).then(resp => {
          this.datoVacunaPers = resp.data
        })
      }
      openModal('ventanaModal')
    },
    fetchVacunas() {
      api.get('/vwvacunas')
        .then(r => { this.vacunas = r.data })
        .catch(e => console.error('Error fetching vacunas:', e))
    },
    fetchVacunaProds(idVacuna) {
      api.get('/vwvacunaprods/idvacuna/' + idVacuna)
        .then(r => { this.vacunaProds = r.data })
        .catch(e => console.error('Error fetching vacunaProds:', e))
    },
    async registrarVacunasRecomendadas() {
      const idPersona    = this.p_idPersona
      const idUsuarioReg = window.sessionStorage.getItem("idUsuario")
      if (!idPersona || !idUsuarioReg) {
        Swal.fire({ icon: 'warning', title: 'Parámetros faltantes',
          text: 'Asegúrese de que idPersona e idUsuarioReg están presentes.' })
        return
      }
      try {
        const response = await api.post(`/vacunaperss/registrar-iniciales/${idPersona}/${idUsuarioReg}`)
        this.getDataTodos()
        Swal.fire({ icon: 'success', title: 'Registro Exitoso',
          text: response.data.message || 'Vacunas recomendadas registradas exitosamente.' })
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Error',
          text: 'Error al registrar vacunas: ' + (error.response?.data?.message || error.message) })
      }
    },
    tablaPersona() {
      const base = `/${this.p_idPersona}/${this.p_idAtencion}/${this.p_numero}/${this.p_edad}`
      if      (this.p_edad <= 5)                      this.$router.push('/vacunaperstabla01' + base)
      else if (this.p_edad > 5 && this.p_edad <= 18)  this.$router.push('/vacunaperstabla02' + base)
      else                                             this.$router.push('/vacunaperstabla03' + base)
    },
  },
}
</script>

<style src="@/assets/css/interruptor.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>